import { render } from "./FoodOrderCartIcon.vue?vue&type=template&id=7efa015e"
const script = {}

import "./FoodOrderCartIcon.vue?vue&type=style&index=0&id=7efa015e&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__